﻿import { Price, IPrice } from "./Price";
import { PriceDiscount, IPriceDiscount } from "./PriceDiscount";
import { Product, IProduct } from "./Product";
import moment from 'moment';
import { ItemNumber } from "./ItemNumber";

export enum PriceListStatus {
    Future,
    Active,
    Expired
}

export class PriceList implements IPriceList {
    constructor(priceList?: IPriceList) {
        // initialize typed object from generic object
        this.priceId = priceList?.priceId ?? 0;
        this.name = priceList?.name;
        this.currencyCode = priceList?.currencyCode;
        this.effectiveDate = priceList?.effectiveDate;
        this.expirationDate = priceList?.expirationDate;
        this.prices = priceList?.prices?.map(price => new Price(price, this)) ?? [];
        this.discounts = priceList?.discounts?.map(discount => new PriceDiscount(discount)) ?? [];
        this.products = [];
        if (priceList?.products)
            for (const product of priceList.products)
                this.products.push(new Product(product, this.products));
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return this;
    }

    priceId: number;
    name?: string;
    currencyCode?: string;
    effectiveDate?: string;
    expirationDate?: string;

    prices: Price[];
    discounts: PriceDiscount[];
    products: Product[];

    //Begin Calculated properties

    get status(): PriceListStatus {
        const today = moment().startOf('day');
        if (this.effectiveDate && moment(this.effectiveDate).startOf('day').isAfter(today))
            return PriceListStatus.Future;
        if (this.expirationDate && moment(this.expirationDate).startOf('day').isBefore(today))
            return PriceListStatus.Expired;
        return PriceListStatus.Active;
    }

    get isUserRequired(): boolean {
        const found = this.prices.find(p => { return p.product != null && (p.product.meritItemId != null || p.product.hasUserProperty) });
        return found != null;
    }

    //End Calculated properties

    //Begin Data manipulation methods

    findPrice(productNumber: ItemNumber | string, unitCode?: string, throwNotFound: boolean = false): Price | undefined {
        const price = this.prices.find(p => (p.productNumber === productNumber.toString()) && (!unitCode || p.unitCode === unitCode));
        if (!price && throwNotFound)
            throw new Error(`"${productNumber}" with unit "${unitCode}" does not exist in price list ${this.priceId}`);
        return price;
    }

    //End Data manipulation methods
}

export interface IPriceList {
    priceId: number;
    name?: string;
    currencyCode?: string;
    effectiveDate?: string;
    expirationDate?: string;

    prices: IPrice[];
    discounts: IPriceDiscount[];
    products: IProduct[];
}